<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, getCurrentInstance } from "vue";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import { getMonthNames, getWeekdayNamesShort } from "@/editor/CalenderHelper";
import { getKennungValueDisplay, getKZTitle } from "@/DataHelper";
import { Globals } from "@/Globals";
import { getSiteData, goBack } from "@/NavigationHelper";
import { globalsStt, checkBegriff, globalsBezeichnung } from "@/local";
const props = defineProps<{
  sperre?: boolean;
  aicReise?: number;
  zeitbereich?: any;
  aic?: number;
  anzahlTage?: number;
  sperreNacht?: boolean;
  nameReise?: string;
}>();
const emit = defineEmits(["save", "back"]);
let myHeight: number = window.innerHeight - 200;
let editZeitbereich = AUApi.Current.zeitbereich;
let e1: number = 1;

let tag = ref<number>(0);
let wochenTag = ref<string>("");
let monat = ref<string>("-");
let reiseBezeichnung = ref<string>("-");
let selectFahrzeug: boolean = false;
let tab = ref<string>("");
let initalized = ref<boolean>(false);
let sperreNacht = ref<boolean>(false);
let sperre = ref<boolean>(false);
let aicReise = ref<number>(0);
let anzahlTage = ref<number>(0);
const siteData = getSiteData();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_RK_EditWebReisen",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  initalized.value = false;
  anzahlTage.value = siteData.anzahlTage ?? props.anzahlTage;
  sperreNacht.value = siteData.sperreNacht ?? props.sperreNacht;
  sperre.value = siteData.sperre ?? props.sperre;
  if (siteData.nameReise) {
    reiseBezeichnung.value = siteData.nameReise;
  } else if (props.nameReise) {
    reiseBezeichnung.value = props.nameReise;
  }
  if (siteData.aicReise) {
    aicReise.value = siteData.aicReise;
  }
  if (siteData.zeitbereich) {
    pageParams.zeitbereich = siteData.zeitbereich;
  } else if (props.zeitbereich) {
    pageParams.zeitbereich = props.zeitbereich;
  }
  let day = pageParams.zeitbereich.von;
  const Stamm = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
  if (siteData && siteData.aicReise) {
    AUApi.Current.setSyncStamm(Stamm.aic, siteData.aicReise);
    if (!pageParams.jokerStt) {
      pageParams.jokerStt = [];
    }
    pageParams.jokerStt.push({
      sync: siteData.aicReise, // aic Stammsatz
      aic: Stamm.aic, // aic Stammtyp
    });
  }
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    selectFahrzeug = getKennungValueDisplay(
      uiData.data[0],
      "RK_TRANSPORTMITTEL",
      uiData.columns,
    );
  }
  try {
    const days = getWeekdayNamesShort();
    if (!day) {
      day = AUApi.Current.zeitbereich.von;
    }
    const dayLocal = new Date(day);
    const d = dayLocal.getDate();
    wochenTag.value = days[d];
    tag.value = d;
    monat.value = getMonthNames()[dayLocal.getMonth()];
    editZeitbereich = {
      von: day,
      bis: day,
      bereich: "Tag",
    };
    initalized.value = true;
    if (!editZeitbereich) {
      return;
    }
  } catch (e: any) {
    console.error("mounterror: " + e, e?.stack);
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});

async function bewSave() {
  siteData.onReloadData = true;
  const instance = getCurrentInstance();
  if (instance) {
    // Access $refs using instance.proxy.$refs
    const x = instance.proxy?.$refs.kostenBelege as any;
    x?.reloadData();
  }
  onSave(uiData, pageParams);
  // goBack();
  // emit("save");
}
function onReloadData(reloadData: any) {
  siteData.onReloadData = reloadData.dataSaved;
  const instance = getCurrentInstance();
  if (instance) {
    // Access $refs using instance.proxy.$refs
    const x = instance.proxy?.$refs.kostenBelege as any;
    x?.reloadData();
    const y = instance.proxy?.$refs.kostenKM as any;
    y?.reloadData();
  }
}
</script>
<template>
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-card-title class="dvhBackground">
      <v-toolbar density="compact" class="dvhBackground" style="color: white">
        <div class="headline font-weight-light white--text">
          {{ wochenTag }}
        </div>
        <strong class="display-2 font-weight-regular white--text mr-6 pd2"
          >{{ tag }}.</strong
        >
        <div class="headline font-weight-light white--text">
          {{ monat }}
        </div>
        <div class="headline font-weight-light white--text pl-5">
          {{ reiseBezeichnung }}
        </div>
        <v-spacer></v-spacer>
        <!-- <CommonBaseButtons
          :createVisible="false"
          :refreshVisible="false"
          :deleteVisible="false"
          :saveVisible="false"
          backColor="white"
          :showBackText="false"
          backIcon="mdi-close"
          :backVisible="true"
          @back="goBack()"
        ></CommonBaseButtons> -->
      </v-toolbar>
    </v-card-title>

    <v-tabs v-model="tab" density="compact" tile slim>
      <v-tab v-if="checkBegriff('Web_Belege')" value="one">{{
        globalsBezeichnung(Globals.Begriff, "Web_Belege", "Belege")
      }}</v-tab>
      <v-tab v-if="checkBegriff('Web_Essen')" value="two">{{
        globalsBezeichnung(Globals.Begriff, "Web_Essen", "Essen")
      }}</v-tab>
      <v-tab v-if="checkBegriff('Web_Transport')" value="three">{{
        globalsBezeichnung(Globals.Begriff, "Web_Transport", "km-Geld")
      }}</v-tab>
      <v-tab v-if="anzahlTage && anzahlTage !== 0" value="four">{{
        globalsBezeichnung(
          Globals.Begriff,
          "Web_UebersichtTage",
          "Übersicht alle Tage",
        )
      }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" bg-color="success">
        <RkMitarbeiterKostenersatz
          ref="timelines"
          query="Web_ManuelleKostenerfassung"
          editQuery="Web_NewManKostensatz"
          :zeitbereich="editZeitbereich"
          :aicReise="aicReise"
          :nameReise="reiseBezeichnung"
          :backOnSave="false"
          :setSperre="siteData?.sperre"
          @onReloadData="onReloadData"
        ></RkMitarbeiterKostenersatz>
      </v-tabs-window-item>
      <v-tabs-window-item value="two" bg-color="success">
        <v-card height="450px">
          <EditSwitchButton :disabled="sperre" kennung="RK_WEB_FRUEHSTUECK" />
          <EditSwitchButton :disabled="sperre" kennung="RK_WEB_MITTAGESSEN" />
          <EditSwitchButton :disabled="sperre" kennung="RK_WEB_ABENDESSEN" />
          <EditSwitchButton :disabled="sperre" kennung="RK_VOLLE_KOSTENUEBER" />
          <v-divider></v-divider>
          <EditSwitchButton
            v-if="!sperreNacht"
            :disabled="sperre"
            kennung="RK_NPAUSCHALE_JANEIN"
          />
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <CommonBaseButtons
              :deleteVisible="false"
              :createVisible="false"
              :refreshVisible="false"
              :backVisible="false"
              @save="bewSave"
              :saveVisible="!sperre"
            ></CommonBaseButtons>
          </v-card-actions>
        </v-card>
      </v-tabs-window-item>
      <v-tabs-window-item value="three" bg-color="success">
        <RkMitarbeiterKostenersatz
          ref="timelines"
          query="Web_RKEditKmErfassung"
          :zeitbereich="editZeitbereich"
          :aicReise="aicReise"
          :nameReise="reiseBezeichnung"
          :backOnSave="false"
          :setSperre="siteData?.sperre"
          editMask="RkMitarbeiterEditKmErfassung"
          @onReloadData="onReloadData"
          :keinNodeBeleg="true"
        ></RkMitarbeiterKostenersatz>
      </v-tabs-window-item>

      <v-tabs-window-item value="four" bg-color="success">
        <div style="color: #1976d2; padding: 3px; background: lightgrey">
          {{ globalsBezeichnung(Globals.Begriff, "Web_Belege", "Belege") }}
        </div>
        <RkMitarbeiterKostenersatz
          ref="kostenBelege"
          query="Web_Uebersicht_Belege"
          :zeitbereich="editZeitbereich"
          :aicReise="props.aicReise"
          :nameReise="props.nameReise"
          :backOnSave="false"
          :setSperre="true"
          @onReloadData="onReloadData"
        ></RkMitarbeiterKostenersatz>
        <div style="color: #1976d2; padding: 3px; background: lightgrey">
          {{ globalsBezeichnung(Globals.Begriff, "Web_Transport", "km-Geld") }}
        </div>
        <RkMitarbeiterKostenersatz
          ref="kostenKM"
          query="Web_RK_Uebersicht_KM"
          :zeitbereich="editZeitbereich"
          :aicReise="props?.aicReise"
          :nameReise="props?.nameReise"
          :backOnSave="false"
          :setSperre="true"
          @onReloadData="onReloadData"
        ></RkMitarbeiterKostenersatz>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>
<style scoped></style>
